import bold from '../../icons/editor/bold.svg';
import checkmark from '../../icons/editor/checkmark.svg';
import code from '../../icons/editor/code.svg';
import comment from '../../icons/editor/comment.svg';
import copy from '../../icons/editor/copy.svg';
import edit from '../../icons/editor/edit.svg';
import editLink from '../../icons/editor/editLink.svg';
import equation from '../../icons/editor/equation.svg';
import flowchart from '../../icons/editor/flowchart.svg';
import heightLarge from '../../icons/editor/heightLarge.svg';
import heightMedium from '../../icons/editor/heightMedium.svg';
import heightSmall from '../../icons/editor/heightSmall.svg';
import heightXSmall from '../../icons/editor/heightXSmall.svg';
import highlight from '../../icons/editor/highlight.svg';
import iframe from '../../icons/editor/iframe.svg';
import imageLeft from '../../icons/editor/imageLeft.svg';
import imageRight from '../../icons/editor/imageRight.svg';
import italic from '../../icons/editor/italic.svg';
import link from '../../icons/editor/link.svg';
import removeHighlight from '../../icons/editor/removeHighlight.svg';
import spanDefault from '../../icons/editor/spanDefault.svg';
import spanFull from '../../icons/editor/spanFull.svg';
import spanHalf from '../../icons/editor/spanHalf.svg';
import strikethrough from '../../icons/editor/strikethrough.svg';
import unlink from '../../icons/editor/unlink.svg';
import upload from '../../icons/editor/upload.svg';
import expand from '../../icons/expand.svg';
import profile from '../../icons/member.svg';
import blockquote from '../../icons/prefilled/editor/blockquote.svg';
import divider from '../../icons/prefilled/editor/divider.svg';
import h1 from '../../icons/prefilled/editor/h1.svg';
import h2 from '../../icons/prefilled/editor/h2.svg';
import h3 from '../../icons/prefilled/editor/h3.svg';
import hintError from '../../icons/prefilled/editor/hintError.svg';
import hintInfo from '../../icons/prefilled/editor/hintInfo.svg';
import hintSuccess from '../../icons/prefilled/editor/hintSuccess.svg';
import hintWarning from '../../icons/prefilled/editor/hintWarning.svg';
import image from '../../icons/prefilled/editor/image.svg';
import listBulleted from '../../icons/prefilled/editor/listBulleted.svg';
import listChecked from '../../icons/prefilled/editor/listChecked.svg';
import listNumbered from '../../icons/prefilled/editor/listNumbered.svg';
import table from '../../icons/prefilled/editor/table.svg';
import text from '../../icons/prefilled/editor/text.svg';

export const boldIcon = bold;
export const italicIcon = italic;
export const strikethroughIcon = strikethrough;
export const codeIcon = code;
export const h1Icon = h1;
export const h2Icon = h2;
export const h3Icon = h3;
export const listBulletedIcon = listBulleted;
export const listNumberedIcon = listNumbered;
export const listCheckedIcon = listChecked;

export const blockquoteIcon = blockquote;
export const hintWarningIcon = hintWarning;
export const hintInfoIcon = hintInfo;
export const hintErrorIcon = hintError;
export const hintSuccessIcon = hintSuccess;

export const tableIcon = table;
export const imageIcon = image;
export const iframeIcon = iframe;
export const dividerIcon = divider;
export const profileIcon = profile;
export const linkIcon = link;
export const textIcon = text;
export const commentIcon = comment;
export const editIcon = edit;
export const copyIcon = copy;
export const unlinkIcon = unlink;
export const editLinkIcon = editLink;
export const checkmarkIcon = checkmark;
export const spanFullIcon = spanFull;
export const spanDefaultIcon = spanDefault;
export const spanHalfIcon = spanHalf;
export const imageLeftIcon = imageLeft;
export const imageRightIcon = imageRight;
export const highlightIcon = highlight;
export const removeHighlightIcon = removeHighlight;
export const heightLargeIcon = heightLarge;
export const heightMediumIcon = heightMedium;
export const heightSmallIcon = heightSmall;
export const heightXSmallIcon = heightXSmall;
export const uploadIcon = upload;
export const expandIcon = expand;
export const flowchartIcon = flowchart;
export const equationIcon = equation;
